
export default function targetPath(){

    const defaultPath = '/enrollments';

    let targetPath = window.sessionStorage.getItem('targetPath');

    if(!targetPath) return defaultPath;

    const forbidden = ['/', '/login', '/logout', '/register'].includes(targetPath);

    targetPath = forbidden ? defaultPath : targetPath;
        
    window.sessionStorage.removeItem('targetPath')

    return targetPath;
}